import { BLANK_TILE_POINTS, TILE_INVENTORY } from './tile-inventory';

/** Characters a rack holds, not tiles: a two-character tile takes two of its eight places. */
export const RACK_CAPACITY = 8;

/** Rack places a tile takes: one per character of its face. */
export const tileSpan = (face: string): number => Math.max(face.length, 1);

/** Places `faces` take together. */
export const rackSpan = (faces: readonly string[]): number => faces.reduce((total, face) => total + tileSpan(face), 0);

/** Whether `face` is a blank: `?`, `??` or `???`. */
export const isBlank = (face: string): boolean => /^\?{1,3}$/.test(face);

const POINTS = new Map(TILE_INVENTORY.map(([face, points]) => [face, points]));

/** What a face scores at face value. Throws a `RangeError` for a face that is neither in the inventory nor a blank. */
export function facePoints(face: string): number {
  if (isBlank(face)) return BLANK_TILE_POINTS;
  const points = POINTS.get(face);
  if (points === undefined) throw new RangeError(`No tile has the face ${JSON.stringify(face)}`);
  return points;
}

/** `points`, held to `swappedTilePoints` for a tile drawn in a swap. `null` (or absent) leaves face value. */
export const cappedPoints = (points: number, swappedTilePoints: number | null | undefined): number =>
  swappedTilePoints === null || swappedTilePoints === undefined ? points : Math.min(points, swappedTilePoints);
